import React from 'react';
import { motion } from 'framer-motion';
import './Contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact section">
      <div className="container">
        <div className="section-header text-center mb-4">
          <h2>Contact Orient Engineers</h2>
          <p>Ready for professional electrical solutions? Get in touch with our electrical installation experts!</p>
        </div>
        
        <div className="contact-info">
          {[
            { icon: 'fas fa-map-marker-alt', title: 'Location', content: '9 Mount Zion Road\nUmule Aba\nAbia State, Nigeria' },
            { icon: 'fas fa-phone', title: 'Phone', content: '08101717017' },
            { icon: 'fas fa-clock', title: 'Hours', content: 'Mon - Fri: 8:00 AM - 6:00 PM\nSat: 9:00 AM - 4:00 PM\nSunday: Emergency Calls Only' }
          ].map((info, index) => (
            <motion.div 
              key={index}
              className="info-item"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2, duration: 0.6 }}
              whileHover={{ y: -5, scale: 1.02 }}
            >
              <motion.div 
                className="info-icon"
                whileHover={{ scale: 1.1, rotate: 5 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <i className={info.icon}></i>
              </motion.div>
              <div className="info-content">
                <h4>{info.title}</h4>
                <p>{info.content.split('\n').map((line, i) => (
                  <span key={i}>{line}{i < info.content.split('\n').length - 1 && <br />}</span>
                ))}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;